<template>
  <!-- _________________________ RESET PASSWORD _________________________ -->
  <div id="login-div" class="position-absolute">

    <div class="mt-4 mb-4 d-flex justify-content-between" @click="backToLogin">
      <back-arrow :title="$t('ChangePassword.newPassword')"/>
    </div>

    <b-alert :show="ui.showError" variant="danger">
      {{ ui.showErrorMessage }}
    </b-alert>

    <div>

      <b-alert :show="ui.showSuccess" variant="success" class="mt-5">
        {{$t('ChangePassword.success')}}
        <br/>
      </b-alert>

      <form ref="form" @submit.stop.prevent="handleSubmit" class="mt-4">

        <password-creation-field
          :password="form.newPassword"
          :label="$t('NewPassword')"/>

        <password-creation-field
          :password="form.newPasswordRepeat"
          :label="$t('NewPassword.confirm')"/>

        <div class="mt-4">
          <b-button type="submit" class="btn-block" variant="primary">{{$t('Validate')}}</b-button>
        </div>

      </form>
    </div>

  </div>
</template>

<script>

import api from '../../../services/api'
import BackArrow from "../../../components/b122/BackArrow.vue";
import PasswordCreationField from "../../../components/b122/editFields/PasswordCreationField.vue";

export default {

  name: 'ResetPasswordComponent',
  components: {PasswordCreationField, BackArrow},

  data () {
    return {
      token: this.$route.params.token,
      userId: this.$route.params.userId,
      form: {
        newPassword: {
          value: null,
          state: null,
          invalidFeedback: null
        },
        newPasswordRepeat: {
          value: null,
          state: null,
          invalidFeedback: null
        }
      },
      ui: {
        showSuccess: false,
        showError: false,
        showErrorMessage: ''
      }
    }
  },

  emits: ['showLoginView'],

  mounted () {
    this.checkToken()
  },

  methods: {

    checkToken () {
      let data = new FormData()
      data.append('token', this.token)
      data.append('userId', this.userId)

      api({
        method: 'POST',
        url: `/forgotPassword/checkResetPasswordToken`,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    handleSubmit () {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('token', this.token)
      formData.append('userId', this.userId)
      formData.append('newPassword', this.form.newPassword.value.trim())

      api({
        method: 'POST',
        url: `/forgotPassword/resetPassword`,
        data: formData
      })
        .then(() => {
          this.ui.showSuccess = true
          this.ui.showError = false
          setTimeout(() => {
            this.backToLogin()
          }, 3000);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    isFormValid () {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }
      if (this.form.newPassword.value == null || this.form.newPassword.value.trim() === '') {
        this.form.newPassword.state = false
        this.form.newPassword.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.newPassword.value.trim().length < 8) {
        this.form.newPassword.state = false
        this.form.newPassword.invalidFeedback = this.$i18n.t('Password.minlenght.error')
        return false
      } else if (this.form.newPasswordRepeat.value == null || this.form.newPasswordRepeat.value.trim() === '') {
        this.form.newPasswordRepeat.state = false
        this.form.newPasswordRepeat.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.newPassword.value !== this.form.newPasswordRepeat.value) {
        this.form.newPasswordRepeat.state = false
        this.form.newPasswordRepeat.invalidFeedback = this.$i18n.t('NewPassword.not.corresponding')
        return false
      }
      return true
    },

    backToLogin () {
      this.$emit('showLoginView')
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ResetPasswordComponent.vue